import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/components/login/Login.vue';
import SignAgree from '@/components/login/SignAgree.vue';
import SignUp from '@/components/login/SignUp.vue';
import FindAccountId from '@/components/login/FindAccountId.vue';
import FindAccountPassword from '@/components/login/FindAccountPassword.vue';
//smart24
import Home from '@/components/home/Home.vue';
import CollectDataList from '@/components/collectData/CollectDataList.vue';
import ParticipantList from '@/components/participant/ParticipantList.vue';
import CareList from '@/components/care/CareList.vue';
import SettingList from '@/components/setting/SettingList.vue';
import CoordiList from '@/components/coordinator/CoordiList.vue';
import UserList from '@/components/user/UserList.vue';
import DataExportList from '@/components/export/DataExportList.vue';
import moment from 'moment';

Vue.use(VueRouter);

//Config
Vue.prototype.config = {
    contextRoot: '',
    proxyServerUrl: window.location.protocol +
        '//' +
        window.location.host +
        ':2424',
};

const routes = [{
        path: Vue.prototype.config.contextRoot + '/login',
        component: Login
    },
    {
        path: Vue.prototype.config.contextRoot + '/login/sign/agree',
        component: SignAgree,
    },
    {
        path: Vue.prototype.config.contextRoot + '/login/sign/up',
        component: SignUp,
    },
    {
        path: Vue.prototype.config.contextRoot + '/login/find/account/id',
        component: FindAccountId,
    },
    {
        path: Vue.prototype.config.contextRoot + '/login/find/account/password',
        component: FindAccountPassword,
    },
    {
        path: Vue.prototype.config.contextRoot + '/home',
        component: Home,
    },
    {
        path: Vue.prototype.config.contextRoot + '/collectData',
        component: CollectDataList,
    },
    {
        path: Vue.prototype.config.contextRoot + '/participant',
        component: ParticipantList,
    },
    {
        path: Vue.prototype.config.contextRoot + '/care',
        component: CareList,
    },
    {
        path: Vue.prototype.config.contextRoot + '/setting',
        component: SettingList,
    },
    {
        path: Vue.prototype.config.contextRoot + '/coordinator',
        component: CoordiList,
    },
    {
        path: Vue.prototype.config.contextRoot + '/user',
        component: UserList,
    },
    {
        path: Vue.prototype.config.contextRoot + '/emr_data_manage',
        component: DataExportList,
    },
    {
        path: Vue.prototype.config.contextRoot + '*',
        redirect: Vue.prototype.config.contextRoot + '/login',
    },
];

//UserInfo
Vue.prototype.userInfo = {
    userId: sessionStorage.getItem('userId'),
    userName: sessionStorage.getItem('userName'),
    roleCd: sessionStorage.getItem('roleCd'),
    isAdmin: function() {
        return sessionStorage.getItem('roleCd') !== undefined &&
            sessionStorage.getItem('roleCd').indexOf('ROLE_ADMIN') >= 0 ?
            true :
            false;
    },
};

//LogLevel
Vue.prototype.logLevel = 'debug'; //debug, warn, error, none

//Logger
Vue.prototype.logger = {
    debug: function(obj, args) {
        if (Vue.prototype.logLevel == 'debug') {
            var exportName = '';
            if (obj instanceof String) {
                exportName = obj;
            } else {
                exportName = obj.$options.name;
            }
            console.log('[' + exportName + ']' + args);
        }
    },
    warn: function(obj, args) {
        if (Vue.prototype.logLevel == 'debug' || Vue.prototype.logLevel == 'warn') {
            var exportName = '';
            if (obj instanceof String) {
                exportName = obj;
            } else {
                exportName = obj.$options.name;
            }
            console.log('[' + exportName + ']' + args);
        }
    },
    error: function(obj, args) {
        if (
            Vue.prototype.logLevel == 'debug' ||
            Vue.prototype.logLevel == 'warn' ||
            Vue.prototype.logLevel == 'error'
        ) {
            var exportName = '';
            if (obj instanceof String) {
                exportName = obj;
            } else {
                exportName = obj.$options.name;
            }
            console.log('[' + exportName + ']' + args);
        }
    },
};

//Utils
Vue.prototype.utils = {
    isNull: function(args) {
        if (args === undefined || args == null || args == '') {
            return true;
        } else {
            return false;
        }
    },
    isEmpty: function(args) {
        return this.isNull(args);
    },
    formatDate(value) {
        return moment(value).format('YYYY-MM-DD');
    },
    deepCopy: function(args) {
        return JSON.parse(JSON.stringify(args));
    },
    getEventPath: function(event) {
        let path = event.path;
        if (event.path === undefined || event.path == null) {
            path = event.composedPath;
            if (event.path === undefined || event.path == null) {
                path = event.composedPath();
            }
        }
        return path;
    }
};

//AXIOS ExceptionHandler
Vue.prototype.exceptionHandler = function(obj, errors) {
    Vue.prototype.logger.debug(obj, errors);
    console.log(errors.response);

    if (!Vue.prototype.utils.isEmpty(errors.response.status)) {
        let statusCode = errors.response.status;
        let errorData = Vue.prototype.utils.isEmpty(errors.response.data.error) ?
            errors.response.status :
            errors.response.data.error;
        let message = Vue.prototype.utils.isEmpty(errors.response.data.message) ?
            errors.response.statusText :
            errors.response.data.message;

        if (statusCode == 403) {
            alert('[' + errorData + ']' + message);

            sessionStorage.setItem('userId', '');
            sessionStorage.setItem('userName', '');
            sessionStorage.setItem('roleCd', '');
            Vue.prototype.userInfo = {};
            this.$router.push(Vue.prototype.config.contextRoot + '/login');
        } else {
            alert('[' + errorData + ']' + message);

            // this.$router.push(Vue.prototype.config.contextRoot);
        }
    }
};

console.log(Vue.prototype.config.proxyServerUrl);
console.log(Vue.prototype.config.contextRoot);

const router = new VueRouter({
    mode: 'history',
    routes,
});

router.beforeEach((to, from, next) => {
    // console.log(to.fullPath);
    console.log('[router.js]path:' + from.path + ' --> ' + to.path);
    console.log('this.userInfo.userId:' + Vue.prototype.userInfo.userId);
    if (
        to.path.indexOf('/login') == -1 &&
        (Vue.prototype.utils.isNull(sessionStorage.getItem('roleCd')) ||
            sessionStorage.getItem('roleCd') == 'ROLE_ANONYMOUS')
    ) 
    {
        Vue.prototype.userInfo = {};
        sessionStorage.setItem('roleCd', '');
        sessionStorage.setItem('userId', '');
        sessionStorage.setItem('userName', '');
        next(Vue.prototype.config.contextRoot);
    }
    else 
    {
        next();
    }
});

export default router;